'use client';

import {AmenitiesModal} from '../amenities';
import {NearbyModal} from '../nearby';
import type {DetailModals} from './useDetailModals';

export interface DetailPageModalsProps {
  amenities: {icon: string; label: string}[];
  modals: DetailModals;
}

export function DetailPageModals({amenities, modals}: DetailPageModalsProps) {
  return (
    <>
      {modals.amenitiesOverflow && <AmenitiesModal open={modals.amenitiesOpen} onClose={modals.closeAmenities} items={amenities} />}
      {modals.nearbyOverflow && <NearbyModal open={modals.nearbyOpen} onClose={modals.closeNearby} places={modals.nearbyPlaces} />}
    </>
  );
}

DetailPageModals.displayName = 'DetailPageModals';
